import { graphql } from 'react-apollo';

import gql from 'graphql-tag';

import user from 'js/lib/user';

import GroupMember from 'bundles/author-groups/models/GroupMember';
import MemberConstants from 'bundles/author-invitations/constants/MemberConstants';
import type {
  GroupMembershipsV2GetQueryVariables,
  GroupMembershipsV2MembersQuery,
} from 'bundles/naptimejs/resources/__generated__/GroupMembershipsV2';

type InputProps = {
  groupId: string;
};

export type WithGroupMembersProps = InputProps & {
  groupMembers?: GroupMember[];
};

type UserPublicProfile = {
  id: number;
  externalUserId: string;
};

// TODO: limit
/* eslint-disable graphql/template-strings */
export const groupMembersQuery = gql`
  query GroupMembershipsGetByGroupQuery($id: String!, $limit: Number!) {
    GroupMembershipsV2 @naptime {
      members(groupId: $id, includes: userPublicProfiles, limit: $limit) {
        elements {
          id
          userId
          groupId
          isViewAsLearnerMembership
          role
          userData {
            typeName
            definition {
              fullName
              firstName
              lastName
              email
              externalId
            }
          }
        }
        linked {
          userPublicProfilesV1 {
            id
            externalUserId
          }
        }
      }
    }
  }
`;
/* eslint-enable graphql/template-strings */

const withGroupMembers = graphql<
  InputProps,
  GroupMembershipsV2MembersQuery,
  GroupMembershipsV2GetQueryVariables,
  WithGroupMembersProps
>(groupMembersQuery, {
  options: ({ groupId }) => ({
    variables: { id: groupId, limit: MemberConstants.Pagination.MEMBERS_LIMIT },
  }),
  skip: ({ groupId }) => !groupId,
  props: ({ data, ownProps }) => {
    // static/bundles/author-groups/actions/GroupMembershipActions.js
    if (data?.GroupMembershipsV2?.members?.elements && data?.GroupMembershipsV2?.members?.linked) {
      const members = data.GroupMembershipsV2.members.elements;
      // @ts-expect-error Autogenerated types are incorrect, they don't include userPublicProfilesV1
      const userPublicProfiles = (data.GroupMembershipsV2.members.linked?.userPublicProfilesV1 ||
        []) as UserPublicProfile[];

      let groupMembers = members.map((member) => {
        const userPublicProfile = userPublicProfiles.find((publicProfile) => publicProfile.id === member.userId);

        // userPublicProfile may be `undefined` in some cases - see PARTNER-18352
        // @ts-expect-error userData is incompatible with auto-generated types
        return new GroupMember({ ...member, externalUserId: userPublicProfile?.externalUserId });
      });

      // Hide superusers from the members list if the user accessing
      // the page is not a superuser
      if (!user.isSuperuser) {
        groupMembers = groupMembers.filter((member) => {
          return member.email && member.email.indexOf('coursera.org') === -1;
        });
      }
      return {
        ...ownProps,
        groupMembers,
      };
    }
    return ownProps;
  },
});

export default withGroupMembers;
